// Sortable — the one useSortable wrapper for the web editor (Doc 06 §7). Used for
// item rows, todo rows, AND category cards: it registers the element with the
// enclosing SortableContext and hands drag-activator props to its children so the
// visual drag handle (not the whole element) starts the drag.

import type { ReactNode } from "react";
import type { DraggableAttributes, DraggableSyntheticListeners } from "@dnd-kit/core";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

// Spread these onto the drag-handle element (see DragHandle) to make it the activator.
export interface SortableHandleProps {
  listeners: DraggableSyntheticListeners;
  attributes: DraggableAttributes;
}

export const Sortable = ({
  id,
  disabled,
  children,
}: {
  id: string;
  disabled: boolean;
  children: (handleProps: SortableHandleProps) => ReactNode;
}): ReactNode => {
  const { setNodeRef, transform, transition, isDragging, listeners, attributes } = useSortable({ id, disabled });
  return (
    <div
      ref={setNodeRef}
      style={{ transform: CSS.Transform.toString(transform), transition, opacity: isDragging ? 0.4 : undefined }}
    >
      {children({ listeners, attributes })}
    </div>
  );
};
